<div class="rich-text-container">
  <ng-container *ngIf="sanitizedHtml; else emptyContent">
    <div [innerHTML]="sanitizedHtml"></div>
  </ng-container>
  <ng-template #emptyContent>
    <p>Rich Text content is unavailable.</p>
  </ng-template>
</div>
